import { makeStyles, createStyles, Typography } from '@material-ui/core'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../components/Button/Button'
import { getTranslations } from '../i18n'
import { setFullLocale } from '../utils/utils'
import { createClient, getSingleDocument } from '../prismicio'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
    },
    smallSpace: {
      marginBottom: 30,
    },
    logo: {
      width: 300,
      marginBottom: 30,
    },
  })
)

type Tprops = {
  main: any
}

const Custom404 = ({ main }: Tprops) => {
  const classes = useStyles()
  const router = useRouter()
  const { t } = useTranslation()

  return (
    <div className={classes.root}>
      {main?.data?.logo?.url && (
        <img src={main.data.logo.url} alt={''} className={classes.logo} />
      )}
      <Typography
        variant={'h1'}
        data-testid="title-404"
        className={classes.smallSpace}
      >
        {t('texts:404:title')}
      </Typography>
      <Button
        variant={'contained'}
        color={'secondary'}
        onClick={() => {
          router.push('/')
        }}
      >
        {t('texts:404:cta')}
      </Button>
    </div>
  )
}

export default Custom404

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const general = await getSingleDocument(client, lang, 'general')

  return {
    props: {
      main: general,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}
